<template>
<!--  <v-app dark>-->
  <v-app>
    <header-component
        v-if="authState && permissionsDefault"
        :authState="authState"
        :permissionsListDefault="permissionsDefault"
    ></header-component>
    <v-sheet id="scrolling-techniques-6" class="overflow-y-auto app-container">
      <router-view/>
    </v-sheet>
    <alert-component v-if="getAlert" :data-alert="getAlert"></alert-component>
    <warning v-if="getWarning" :dataWarn="getWarning"></warning>
    <preload v-if="getPreloader"></preload>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
// components
import HeaderComponent from "@/shared/HeaderComponent/HeaderComponent";
import AlertComponent from "@/shared/AlertComponent/AlertComponent";
import Warning from "@/shared/AlertComponent/Warning";
import Preload from "@/shared/Preload/Preload";

export default {
	name: "App",
	components: {
		HeaderComponent,
		AlertComponent,
		Warning,
		Preload
	},

	data: () => ({
		routeName: null,
		routeSelected: null,
	}),
	computed: mapGetters([ 'getWarning', 'authState', 'permissionsDefault', 'getAlert', 'getPreloader', 'permissions', 'getPermissionsList' ]),
	async mounted() {
		this.routeName = this.$route.name;
	},

	methods: {
		updateRouteSelected() {
			const permission = this.getPermissionsList.find((perm) => {
				return perm.name === this.routeName;
			});

			if (permission) {
				this.routeSelected = permission.selected;

				if (!this.routeSelected) {
					this.$router.push('/'); // Редирект на главную, если доступ запрещён
				}
			}
		},
	},

	watch: {
		'$route'(to) {
			this.routeName = to.name;
		},
		getPermissionsList: {
			handler() {
				this.updateRouteSelected();
			},
			deep: true, // Следим за изменением внутри массива
			immediate: true, // Запускаем при загрузке компонента
		},
	},

	// provide() {
	// 	return {
	// 		themeIsDark: this.$vuetify.theme.dark
	// 	};
	// },
	// // // Вкл Темная тема
	// // created() {
	// // 	this.$vuetify.theme.dark = true; // 💀 Насильна темрява
	// // 	localStorage.removeItem('theme'); // ⛔ Випалити спогади
	// // },
	// // // Вкл Темная тема
};
</script>

<style lang="scss">
.light-theme {
	--bg-color: white;
	--text-color: black;
}

.dark-theme {
	--bg-color: #121212;
	--text-color: white;
}

body {
	background-color: var(--bg-color);
	color: var(--text-color);
	transition: background-color 0.3s, color 0.3s;
}
@import "app";
</style>
